import { Auth } from 'aws-amplify';

export interface OptimiseUser {
  id: number;
  username: string;
  attributes: {
    address: string;
    'custom:is_onboarded': 'true' | 'false';
    'custom:postcode': string;
    email: string;
    email_verified: boolean;
    name: string;
    sub: string;
  };
}

export const getAuthIdToken = async () => {
  return await Auth.currentSession().then((res) => res.getIdToken());
};

export const getCurrentUserInfo = async (): Promise<OptimiseUser | undefined> => {
  const res = await Auth.currentUserInfo();
  if (!res) {
    console.error('Error: Auth.currentUserInfo() returned undefined');
  }
  return res;
};

export const isSignedIn = async () => {
  return await getAuthIdToken().then((res) => !!res);
};

export const signOut = async () => {
  try {
    await Auth.signOut().then(() => {
      localStorage.clear();
      return (window.location.href = '/');
    });
  } catch (error) {
    console.error('Error signing out: ', error);
  }
};
